import './pages.css';
import { useLocation } from 'react-router-dom';
import qtStoreImage from '../assets/qt-store.png';
import devxUiImage from '../assets/devx-ui.webp';
import testPyramidImage from '../assets/test-pyramid.png';
import { ExternalLink } from 'lucide-react';
import SendIdentity from '../components/UXAnalytics';

function Home({ userEmail }) {
    const location = useLocation();

    return (
      <div className="application-container">
        {location.pathname === '/home' && (
          <>
            {userEmail && <SendIdentity Email={userEmail} />}
            <div className="container home-cards">
              <div className="header">
                <h1>Welcome to Quality Hub</h1>
              </div>
              <div className="card home-card">
                  <div className="home-card-media"><img src={qtStoreImage} alt="Qt Store" className="card-image" /></div>
                  <h2>Generation test data for any CSQ project</h2>
                  <p>Generate test data for any web project, through a simple and flexible TAG deployment. Our test website offers a wide range of data generation options, including login, purchase, and more.</p>
                  <button onClick={() => window.open('https://qt-store-frontend-staging.eu-west-1.csq.io/es/store?sortBy=price_desc', '_blank')}>
                      Explore QT store website <ExternalLink size={16} />
                  </button>
              </div>
              <div className="card home-card">
                  <div className="home-card-media"><img src={testPyramidImage} alt="Test Pyramid" className="card-image" /></div>
                  <h2>Explore our test pyramid automation concept</h2>
                  <p>The testing pyramid is a model that provides a structure for assessing the types of tests to be performed in an automated test suite. Explore the Engineering blog article published by our Quality team.</p>
                  <button onClick={() => window.open('https://engineering.contentsquare.com/2023/misshapen-test-pyramid-and-the-journey-to-recreate-it/', '_blank')}>
                      Explore Engineering blog article <ExternalLink size={16} />
                  </button>
              </div>
              <div className="card home-card">
                  <div className="home-card-media"><img src={devxUiImage} alt="DevX UI" className="card-image devx-image" /></div>
                  <h2>DevX UI: developer tools</h2>
                  <p>Explore the developer tools at Contentsquare, including the Translations UI and the Feature Flags UI for managing translation keys and feature flags.</p>
                  <button onClick={() => window.open('https://frontends-dev.contentsquare.com/devx-ui/latest/index.html#/', '_blank')}>
                      Explore DevX UI <ExternalLink size={16} />
                  </button>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }

export default Home; 